<template>
  <div>
    <div class="text-center">
      <div v-if="$refs.upload && $refs.upload.dropActive" class="bg-blue-200 p-4">
        <h3>Drop files to upload.</h3>
      </div>
      <div v-else>
        <!-- @slot Set description. -->
        <slot>
          <h2 class="p-4">Drag and drop files here or <label for="file" class="text-blue-500 cursor-pointer">browse files.</label></h2>
        </slot>
      </div>
    </div>
    <div v-if="files.length" class="justify-center text-center bg-cool-gray-100 p-2">
      <!-- @slot Override how the list of files are presented. -->
      <slot name="filelist" v-bind:files="files">
        <div v-for="file in files" :key="file.id" class="">
          <span class="font-semibold">{{ file.name }}</span> - <span>{{ $filters.formatSize(file.size) }}</span> -
          <span v-if="file.error" class="text-red-500">( {{ file.error }} )</span>
          <span v-else-if="file.success" class="text-green-500">Success</span>
          <span v-else-if="file.active">Active</span>
          <span v-else class="text-yellow-700">Pending</span>
        </div>
      </slot>
      <button type="button" class="mt-2" v-if="action && (!$refs.upload || !$refs.upload.active)" @click.prevent="$refs.upload.active = true">
        Start Upload
      </button>
    </div>
    <file-upload class="hidden" :post-action="action" :multiple="true" :drop="true" :drop-directory="true" v-model="files" ref="upload"></file-upload>
  </div>
</template>

<script>
import FileUpload from 'vue-upload-component'

export default {
  name: 'FormFile',
  components: {
    FileUpload
  },
  props: {
    modelValue: {
      type: Array
    },
    action: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  computed: {
    files: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  }
}
</script>

<style>
span.file-uploads {
  display: none;
}
</style>
